import { Css, FormSectionProps, UseModalHook } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { ConfigureBidGroupsStepQuery } from "src/routes/bids/plan-based-bid-package/components/2.ConfigureBidGroupsStep.generated";
import { BaseCostDimensionsModal } from "src/routes/bids/plan-based-bid-package/components/BaseCostDimensionsModal";
import { BidPlanDimensionRows } from "src/routes/bids/plan-based-bid-package/components/BidPlanDimensionRows";
import { groupKey, isBaseGroup, PlanBasedBidPackageFormState } from "src/routes/bids/plan-based-bid-package/utils";

type BuildBaseBidCostDimensionsSectionParams = {
  formState: ObjectState<PlanBasedBidPackageFormState>;
  dimensionResults: ConfigureBidGroupsStepQuery["potentialBidPlanDimensions"];
  openModal: UseModalHook["openModal"];
};

/** Builds the "Base Bid Cost Dimensions" `FormSection`, shown only when `baseBidType` is Standard. */
export function buildBaseBidCostDimensionsSection(params: BuildBaseBidCostDimensionsSectionParams): FormSectionProps {
  const { formState, dimensionResults, openModal } = params;
  const baseGroups = formState.bidPlanGroups.rows.filter((g) => isBaseGroup(g.value));
  const hasDimensions = baseGroups.some((g) => g.dimensions.rows.nonEmpty);

  return {
    title: "Base Bid Cost Dimensions",
    description:
      "Add cost dimensions that affect the base bid. If none are added, the base bid will have one cost line per product offering.",
    actions: [
      {
        icon: "plus",
        label: "Add Cost Dimension",
        variant: "secondary",
        onClick: () =>
          openModal({ content: <BaseCostDimensionsModal formState={formState} dimensionResults={dimensionResults} /> }),
      },
    ],
    fields: !hasDimensions ? (
      <div css={Css.bgGray100.br8.py3.tac.gray700.$}>No cost dimensions added.</div>
    ) : (
      <div css={Css.df.fdc.gap2.$}>
        {baseGroups.map((group) => (
          <div key={groupKey(group.value)} css={Css.bcGray200.pt1.$}>
            <BidPlanDimensionRows group={group} dimensionResults={dimensionResults} />
          </div>
        ))}
      </div>
    ),
  };
}
